import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles, Crown } from 'lucide-react';

const SubscriptionSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate('/app/home');
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white rounded-3xl shadow-2xl p-8 md:p-12 text-center">
        {/* Success Icon */}
        <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-green-400 to-green-600 rounded-full mb-6 animate-bounce">
          <CheckCircle className="w-12 h-12 text-white" />
        </div>

        {/* Crown Icon */}
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full mb-6">
          <Crown className="w-8 h-8 text-white" />
        </div>

        {/* Success Message */}
        <h1 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent mb-4">
          Welcome to Growth! 🎉
        </h1>
        
        <p className="text-xl text-gray-700 mb-6">
          Your subscription has been activated successfully!
        </p>

        {/* Features Unlocked */}
        <div className="bg-gradient-to-r from-pink-100 to-purple-100 rounded-2xl p-6 mb-8">
          <h2 className="text-lg font-semibold text-gray-900 mb-4 flex items-center justify-center gap-2">
            <Sparkles className="w-5 h-5 text-pink-500" />
            You now have unlimited access to:
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left">
            <div className="flex items-center gap-2">
              <span className="text-2xl">💬</span>
              <span className="text-sm text-gray-700">Unlimited Conchi conversations</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">✨</span>
              <span className="text-sm text-gray-700">Unlimited AI journal insights</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">🌟</span>
              <span className="text-sm text-gray-700">Unlimited daily affirmations</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-2xl">🌸</span>
              <span className="text-sm text-gray-700">Unlimited Love Garden sessions</span>
            </div>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => navigate('/app/home')}
            className="px-8 py-4 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-bold rounded-full shadow-lg hover:shadow-xl transition-all"
          >
            Start Your Journey →
          </button>
          <button
            onClick={() => navigate('/app/profile')}
            className="px-8 py-4 bg-white border-2 border-gray-300 hover:border-gray-400 text-gray-700 font-semibold rounded-full transition-all"
          >
            View Profile
          </button>
        </div>

        {/* Auto-redirect notice */}
        <p className="text-sm text-gray-500 mt-6">
          Redirecting to your dashboard in a few seconds...
        </p>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
